import {
  GET_ALL_ITEM_RECIEPT_DETAIL_REPORT_REQUEST,
  GET_ALL_ITEM_RECIEPT_DETAIL_REPORT_SUCCESS,
  GET_ALL_ITEM_RECIEPT_DETAIL_REPORT_ERROR,
  } from "../actions/types";
  
  export const ItemReceiptDetail = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_ALL_ITEM_RECIEPT_DETAIL_REPORT_REQUEST:
        return {
          loading: true,
        };
      case GET_ALL_ITEM_RECIEPT_DETAIL_REPORT_SUCCESS:
        return {
          ...state,
          loading: false,
          payload: payload,
        };
      case GET_ALL_ITEM_RECIEPT_DETAIL_REPORT_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  